import CasinoIcon from '@mui/icons-material/Casino';
import { PERMISSIONS } from '../../constants';
import { ROLETA_RESOURCE } from '../../models/roleta';
import RoletaCreate from './RoletaCreate';
import RoletaEdit from './RoletaEdit';
import RoletaList from './RoletaList';
import RoletaShow from './RoletaShow';

/**
 * Nome LONGO de propósito (`chains/chainId/roletas`, como `drawings`):
 * `store/providers/getMany.ts` não consulta o `mapPath`, então nome curto +
 * mapPath quebraria ReferenceField/ReferenceInput apontando para a roleta.
 *
 * Permissão reaproveitada: `gift`. A roleta é uma peça do Clube de Vantagens —
 * permissão nova se cria pela tela Configurações → Permissões, nunca por código.
 */
export default {
  list: RoletaList,
  create: RoletaCreate,
  edit: RoletaEdit,
  show: RoletaShow,
  name: ROLETA_RESOURCE,
  permissions: [PERMISSIONS.GIFT],
  options: { label: 'Roletas' },
  icon: CasinoIcon,
};
